import script from "./LockedSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LockedSection.vue?vue&type=script&setup=true&lang=js"

import "./LockedSection.vue?vue&type=style&index=0&id=498c8a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498c8a30"]])

export default __exports__